import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import { push } from 'react-router-redux';

import { loginRoutine } from '../../../routines';

import { authService } from '../../../sagas/authentication';

import styles from './styles';

class Login extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
  };

  render() {
    //TODO display email verification message
    //this.props.location.search

    const { state } = this.props.location;

    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>
        {state && state.message ? <Paper zDepth={3} style={styles.message}>{state.message}</Paper> : null}
        <div>
          <RaisedButton label="Login" secondary fullWidth style={styles.login} onClick={() => authService.login()}/>
          <RaisedButton type="button" label="Register" fullWidth style={styles.register}
                        onClick={() => this.props.push('/register')}/>
        </div>
      </div>

    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    push,
    login: loginRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Authentication/Login/index.js